import {
  Box,
  FormControl,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CloseModalIcon from "../icons/CloseModalIcon";
import CustomButton from "../common/CustomButton";
import ModalDepositPaymentTransfer from "./ModalDepositPaymentTransfer";

const root = {
  position: "absolute",
  top: { xs: "40%", sm: "40%", md: "40%" },
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "80%", // 90% width on extra small screens
    sm: "80%", // 80% width on small screens
    md: "40%", // 60% width on medium screens
    lg: "30%", // 40% width on large screens
  },
  height: {
    xs: "40%", // 90% width on extra small screens
    sm: "40%", // 80% width on small screens
  },
  bgcolor: "#15141B",
  color: "white",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  p: 3,
};

const iconContainer = {
  position: "absolute",
  cursor: "pointer",
  right: { xs: 30, sm: 16 },
  top: { xs: 30, sm: 16 },
  backgroundColor: "transparent",
};

const icon = {
  height: { xs: "12px" },
  width: { xs: "12px" },
};

export default function ModalDeposit({
  open = false,
  handleDeposit = () => {},
  handleClose = () => {},
  ...props
}) {
  const [openPayment, setOpenPayment] = useState(false);
  const [value, setValue] = useState(0);
  const [error, setError] = useState(false);
  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue !== "" || parseFloat(newValue) > 0) {
      setValue(newValue);
      setError(false); // Clear the error if valid
    } else {
      setError(true); // Set error if invalid
    }
    setValue(newValue);
  };
  const [loading, setLoading] = useState(true);
  return (
    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={root} onClick={handleClose}>
          <Box sx={iconContainer}>
            <CloseModalIcon sx={icon} />
          </Box>
          <Box
            onClick={(event) => event.stopPropagation()}
            id="modal-modal-description"
            sx={{
              p: 5,
              overflowX: "auto",
              height: "90%",
              overFlowX: "auto",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari, and Edge
              },
            }}
          >
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
            >
              <Box marginTop={1}>
                <Typography variant="h6" fontWeight={700}>
                  Deposit
                </Typography>
              </Box>
              <Box
                width="100%"
                marginTop={2}
                marginBottom={4}
                display="flex"
                flexDirection="column"
                gap={1}
              >
                <form
                  onSubmit={(e) => {
                    // setOpenPayment(true);
                    e.stopPropagation();
                  }}
                >
                  <Typography
                    variant="body2"
                    fontWeight={200}
                    fontSize={12}
                    color="white"
                    ml={1}
                  >
                    Input amount *
                  </Typography>
                  <Typography color="error" ml={1} fontSize={12}>
                    {error ? "Please enter a number greater than 0." : ""}
                  </Typography>
                  <FormControl sx={{ mb: 3, mt: 1, width: "100%" }}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      required
                      type="number"
                      value={value || ""}
                      error={error}
                      onChange={handleChange}
                      //label="With normal TextField"
                      id="outlined-start-adornment"
                      sx={{
                        backgroundColor: "white",
                        border: "none",
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-root": {
                          height: "48px", // Adjust height here
                          "&.Mui-focused fieldset": {
                            border: "none", // Remove border when focused
                            // appearance: "none",
                          },
                          "& .MuiTypography-root": {
                            color: "black",
                          },
                        },
                        '& input[type="number"]': {
                          // Hides the spinner controls
                          MozAppearance: "textfield", // Firefox
                          appearance: "none", // Chrome
                        },
                        '& input[type="number"]::-webkit-inner-spin-button,': {
                          // Hides the spinner in Chrome/Safari
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        '& input[type="number"]::-webkit-outer-spin-button,': {
                          // Hides the spinner in Chrome/Safari
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                      }}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        },
                      }}
                    />
                  </FormControl>
                </form>
                <CustomButton
                  handleClick={() => {
                    if (!!value && !error) {
                      handleClose();
                      setOpenPayment(true);
                    } else setError(true);
                  }}
                >
                  Continue
                </CustomButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      <ModalDepositPaymentTransfer
        amount={value}
        loading={loading}
        setLoading={setLoading}
        handleDeposit={() => handleDeposit(value)}
        open={openPayment}
        handleClose={() => {
          //reset
          setOpenPayment(false);
          setValue(0);
          setLoading(true);
        }}
      />
    </div>
  );
}
